module.exports = __webpack_public_path__ + "images/banner_02.png?aff2f1088dadd0df222803f854946cdc";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner_02.png
// module id = 215
// module chunks = 1